<template>
  <b-card no-body class="drag mb-1" :class="{ deleteMe: section.delete_me }">
    <b-card-header
      header-tag="header"
      class="py-0 px-1"
      role="tab"
      :class="{ expanded: section.visible }"
    >
      <b-row>
        <b-col
          cols="12"
          md="6"
          lg="3"
          class="d-inline-flex align-items-center v2_font_size_24 my-1"
        >
          <open-icon
            :name="section.visible ? 'chevron-bottom' : 'chevron-right'"
            v-b-toggle="'section_' + sectionId"
          />
          <b-badge variant="info" class="m-1">
            Section {{ section.delete_me ? 'x' : section.order }}
          </b-badge>
        </b-col>
        <b-col cols="12" md="6" lg="3" class="my-1">
          <b-form-input
            @click.stop
            class="section-title-input"
            v-model="section.title"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
            cols="12"
            md="3"
            class="d-inline-flex align-items-center my-1"
        >
          <b-form-checkbox
              v-model="section.is_module"
              :value="1"
              :unchecked-value="0"
          />
          <span class="v2_font_weight_semibold v2_font_size_18">
            Is Module
          </span>
        </b-col>
        <b-col cols="12" md="9" class="my-1">
          <b-form-select
              v-model="sp"
              multiple
              :options="specialtyOptions"
              :disabled="section.is_module !== 1"
              @change="test"
          >
            <template slot="first">
              <option :value="0" >
                -- Any specialty --
              </option>
            </template>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col
            cols="12"
            md="12"
            class="d-inline-flex align-items-center my-2"
        >
          <b-form-checkbox
              v-model="section.is_have_interested_question"
              :value="1"
              :unchecked-value="0"
          />
          <span class="v2_font_weight_semibold v2_font_size_18">
            Is Have Interested Question
          </span>
        </b-col>
      </b-row>
      <div class="actions my-1 float-right">
        <b-btn
          size="sm"
          variant="default"
          @click="$emit('delete-section', section)"
        >
          <open-icon name="delete" />
        </b-btn>
      </div>
      <div class="mb-1">
        <b-form-group label="Description:" label-cols="2" class="mb-0">
          <b-form-textarea
            v-model="section.description"
            rows="3"
            max-rows="3"
            no-resize
          />
        </b-form-group>
      </div>
    </b-card-header>
    <b-collapse
      :id="'section_' + sectionId"
      role="tabpanel"
      v-model="section.visible"
    >
      <b-card-body class="p-1">
        <div class="drag">
          <draggable
            class="dragArea"
            v-model="section.questionSections"
            :options="{ group: 'questions' }"
            @update="$emit('update')"
            @add="$emit('add')"
          >
            <b-card
              no-body
              class="drag mb-1"
              v-for="questionSection in section.questionSections"
              :key="`${section.id}_${questionSection.question_id}`"
              :class="{ deleteMe: questionSection.delete_me }"
            >
              <b-card-header header-tag="header" class="py-0 px-1" role="tab">
                <h6 class="question-header float-left text-left my-1 d-inline">
                  <b-badge variant="info" class="m-1">
                    Question
                    {{ section.delete_me ? 'x' : section.order }}.{{
                      questionSection.delete_me ? 'x' : questionSection.order
                    }}
                  </b-badge>
                  <QuestionId :id="questionSection.question.id">
                    <template slot-scope="{ id }">
                      <a :href="`#/admin/question/edit/${id}`" target="_blank"
                        >Q{{ id }}</a
                      >
                    </template>
                  </QuestionId>
                  {{ questionSection.question.prompt }}
                  <b-badge
                    class="required-badge"
                    variant="danger"
                    v-if="questionSection.question.required"
                  >
                    *
                  </b-badge>
                </h6>
                <div class="actions my-1 float-right">
                  <b-btn
                    size="sm"
                    variant="default"
                    @click="$emit('delete-question-section', questionSection)"
                  >
                    <open-icon name="delete" />
                  </b-btn>
                </div>
              </b-card-header>
              <questionnaire-params-form
                :is-primary="!!questionnaire.isPrimary"
                :question-section="questionSection"
              />
            </b-card>
          </draggable>
          <div class="text-right">
            <QuestionFinder
              :section="section"
              :questionnaire="questionnaire"
              buttonLabel="Add Question..."
            />
          </div>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import draggable from 'vuedraggable';
import QuestionFinder from '@/components/QuestionFinder.vue';
import QuestionId from '@/components/QuestionId.vue';
import QuestionnaireParamsForm from '@/components/questionnaire/QuestionnaireParamsForm';

export default {
  name: 'SectionListItem',
  components: {
    draggable,
    QuestionFinder,
    QuestionId,
    QuestionnaireParamsForm,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    questionnaire: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      sp: [],
    };
  },
  created: function() {
    if (!this.section.specialtyIds || !this.section.specialtyIds.length) {
      this.section.specialtyIds = [0];
      this.sp[0] = 0;
    }
    this.section.specialtyIds.forEach(sId => {
      this.sp.push(sId);
    });
  },
  computed: {
    specialtyOptions: function () {
      return this.questionnaire.society
        ? (this.questionnaire.society.specialties || []).map((s) => {
            return { value: s.id, text: s.title, specialty: s };
          })
        : this.$store.getters.masterSpecialtyOptions;
    },
    sectionId: function () {
      return this.section.id || this.section.uid;
    },
  },
  methods: {
    test: function (specialties) {
      const hasNull = specialties.some((s) => s === 0);
      if (hasNull) {
        this.sp= [0];
      }
    },
  },
  watch: {
    'section.is_module': function (newVal, prevVal) {
      if (!newVal && prevVal) {
        this.section.specialty_id = null;
      }
    },
    sp: function (newVal) {
      this.$set(this.section, 'specialties', newVal);
    },
  },
};
</script>

<style scoped>
.question-header {
  width: 96%;
}
</style>
